import { render, staticRenderFns } from "./HistoryTime.vue?vue&type=template&id=46a99d04&scoped=true&lang=pug&"
var script = {}
import style0 from "./HistoryTime.vue?vue&type=style&index=0&id=46a99d04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a99d04",
  null
  
)

export default component.exports